import React, { useState } from "react";
import Header from "../components/Common/Header/Header";
import Sidenavigation from "../components/Common/Sidenavigation";
import { useLazyQuery } from "@apollo/react-hooks";
import { VIEW_PROFILE } from "../query/ViewProfile";
import { hasuraClient } from "../apolloClient";
import JWTCOMMON from "../components/Common/JWTCommon";

const MainContainer = (props) => {
  const [userData, setUserData] = useState(null);
  const [profileData] = useLazyQuery(VIEW_PROFILE, {
    notifyOnNetworkStatusChange: "true",
    fetchPolicy: "network-only",
    client: hasuraClient,
    onCompleted: (data) => {
      setUserData(data);
    },
  });

  React.useEffect(() => {
    profileData();
  }, []);

  return (
    <>
      <JWTCOMMON />
      <div className="dashboard">
        <div className="sidebar">
          <Sidenavigation active={props.active} />
        </div>
        <div className="wrapper">
          <Header userData={userData} />
          <main className={`${props.className} main`}>{props.children}</main>
        </div>
      </div>
    </>
  );
};
export default MainContainer;
